export const CONDITION_TYPES = [
  { id: 'TRANSACTION_AMOUNT_GT', name: 'Transaction Amount >', needsSecondary: false },
  { id: 'TRANSACTION_AMOUNT_LT', name: 'Transaction Amount <', needsSecondary: false },
  { id: 'TRANSACTION_AMOUNT_GTE', name: 'Transaction Amount >=', needsSecondary: false },
  { id: 'TRANSACTION_AMOUNT_LTE', name: 'Transaction Amount <=', needsSecondary: false },
  { id: 'TRANSACTION_AMOUNT_BETWEEN', name: 'Transaction Amount Between', needsSecondary: true },
  { id: 'VOUCHER_BALANCE_GT', name: 'Voucher Balance >', needsSecondary: false },
  { id: 'VOUCHER_BALANCE_LT', name: 'Voucher Balance <', needsSecondary: false },
  { id: 'VOUCHER_BALANCE_GTE', name: 'Voucher Balance >=', needsSecondary: false },
  { id: 'VOUCHER_BALANCE_LTE', name: 'Voucher Balance <=', needsSecondary: false },
  { id: 'VOUCHER_BALANCE_BETWEEN', name: 'Voucher Balance Between', needsSecondary: true },
];

export const ACTION_TYPES = [
  { id: 'MULTIPLY_RATIO', name: 'Multiply Ratio by', needsValue: true },
  { id: 'ADD_RATIO', name: 'Add Bonus Ratio', needsValue: true },
  { id: 'SET_RATIO', name: 'Set Fixed Ratio to', needsValue: true },
  { id: 'BLOCK_ACCRUAL', name: 'Block All Accrual', needsValue: false },
  { id: 'ADD_FIXED_POINTS', name: 'Add Fixed Points', needsValue: true },
];

export const CONDITION_OPERATORS = [
  { id: 'AND', name: 'All conditions must match (AND)' },
  { id: 'OR', name: 'Any condition must match (OR)' },
];

export const INITIAL_STATE = {
  name: '',
  description: '',
  priority: '',
  isActive: true,
  startDate: '',
  endDate: '',
  conditionOperator: 'AND',
  conditions: [{ conditionType: '', value: '', secondaryValue: '' }],
  actionType: '',
  actionValue: '',
  mccCodes: '',
  selectedTierIds: [],
  loading: false,
  fieldErrors: {},
  conditionErrors: [],
  tiers: [],
  tiersLoading: false,
  existingRules: [],
};

export const PREDEFINED_RULE_DEFAULT_NAME =
  'Enter a unique name for this rule before saving.';

export const PREDEFINED_RULE_DEFAULT_DESCRIPTION =
  'Describe what this rule does and when it applies. Update this before saving.';

export const CATEGORY_COLORS = {
  Threshold: '#e53e3e',
  Bonus: '#38a169',
  Voucher: '#3182ce',
  MCC: '#805ad5',
  Promotional: '#dd6b20',
  Tier: '#6b46c1',
  Combined: '#2c7a7b',
};

export const PREDEFINED_RULES = [
  {
    label: 'Block Below LKR 1,000',
    description: 'No points for transactions under LKR 1,000',
    category: 'Threshold',
    formData: {
      name: PREDEFINED_RULE_DEFAULT_NAME,
      description: PREDEFINED_RULE_DEFAULT_DESCRIPTION,
      priority: '1',
      isActive: true,
      startDate: '',
      endDate: '',
      conditionOperator: 'AND',
      conditions: [{ conditionType: 'TRANSACTION_AMOUNT_LT', value: '1000', secondaryValue: '' }],
      actionType: 'BLOCK_ACCRUAL',
      actionValue: '',
      mccCodes: '',
      selectedTierIds: [],
    },
  },
  {
    label: '+0.5 Ratio for LKR 1,000+',
    description: 'Add 0.5 bonus ratio for transactions ≥ LKR 1,000',
    category: 'Bonus',
    formData: {
      name: PREDEFINED_RULE_DEFAULT_NAME,
      description: PREDEFINED_RULE_DEFAULT_DESCRIPTION,
      priority: '2',
      isActive: true,
      startDate: '',
      endDate: '',
      conditionOperator: 'AND',
      conditions: [{ conditionType: 'TRANSACTION_AMOUNT_GTE', value: '1000', secondaryValue: '' }],
      actionType: 'ADD_RATIO',
      actionValue: '0.5',
      mccCodes: '',
      selectedTierIds: [],
    },
  },
  {
    label: 'Block High Value (≥ LKR 50,000)',
    description: 'No accrual for transactions ≥ LKR 50,000',
    category: 'Threshold',
    formData: {
      name: PREDEFINED_RULE_DEFAULT_NAME,
      description: PREDEFINED_RULE_DEFAULT_DESCRIPTION,
      priority: '1',
      isActive: true,
      startDate: '',
      endDate: '',
      conditionOperator: 'AND',
      conditions: [{ conditionType: 'TRANSACTION_AMOUNT_GTE', value: '50000', secondaryValue: '' }],
      actionType: 'BLOCK_ACCRUAL',
      actionValue: '',
      mccCodes: '',
      selectedTierIds: [],
    },
  },
  {
    label: '2x Bonus for LKR 10,000+',
    description: 'Double points for transactions over LKR 10,000',
    category: 'Bonus',
    formData: {
      name: PREDEFINED_RULE_DEFAULT_NAME,
      description: PREDEFINED_RULE_DEFAULT_DESCRIPTION,
      priority: '3',
      isActive: true,
      startDate: '',
      endDate: '',
      conditionOperator: 'AND',
      conditions: [{ conditionType: 'TRANSACTION_AMOUNT_GT', value: '10000', secondaryValue: '' }],
      actionType: 'MULTIPLY_RATIO',
      actionValue: '2',
      mccCodes: '',
      selectedTierIds: [],
    },
  },
  {
    label: 'Voucher Balance Cap (≥ LKR 1,000)',
    description: 'Block accrual when the current voucher balance is LKR 1,000 or above',
    category: 'Voucher',
    formData: {
      name: PREDEFINED_RULE_DEFAULT_NAME,
      description: PREDEFINED_RULE_DEFAULT_DESCRIPTION,
      priority: '1',
      isActive: true,
      startDate: '',
      endDate: '',
      conditionOperator: 'AND',
      conditions: [{ conditionType: 'VOUCHER_BALANCE_GTE', value: '1000', secondaryValue: '' }],
      actionType: 'BLOCK_ACCRUAL',
      actionValue: '',
      mccCodes: '',
      selectedTierIds: [],
    },
  },
  {
    label: '1.5x for LKR 5,000–20,000',
    description: '1.5x points for transactions between LKR 5,000 and LKR 20,000',
    category: 'Bonus',
    formData: {
      name: PREDEFINED_RULE_DEFAULT_NAME,
      description: PREDEFINED_RULE_DEFAULT_DESCRIPTION,
      priority: '4',
      isActive: true,
      startDate: '',
      endDate: '',
      conditionOperator: 'AND',
      conditions: [{ conditionType: 'TRANSACTION_AMOUNT_BETWEEN', value: '5000', secondaryValue: '20000' }],
      actionType: 'MULTIPLY_RATIO',
      actionValue: '1.5',
      mccCodes: '',
      selectedTierIds: [],
    },
  },
  {
    label: 'Festive Season 2x Points',
    description: '2x points during December promotion (Dec 2026)',
    category: 'Promotional',
    formData: {
      name: PREDEFINED_RULE_DEFAULT_NAME,
      description: PREDEFINED_RULE_DEFAULT_DESCRIPTION,
      priority: '5',
      isActive: true,
      startDate: '2026-12-01T00:00',
      endDate: '2026-12-31T23:59',
      conditionOperator: 'AND',
      conditions: [{ conditionType: 'TRANSACTION_AMOUNT_GTE', value: '1', secondaryValue: '' }],
      actionType: 'MULTIPLY_RATIO',
      actionValue: '2',
      mccCodes: '',
      selectedTierIds: [],
    },
  },
  {
    label: 'Blacklist MCCs',
    description: 'Block accrual for transactions',
    category: 'MCC',
    formData: {
      name: PREDEFINED_RULE_DEFAULT_NAME,
      description: PREDEFINED_RULE_DEFAULT_DESCRIPTION,
      priority: '1',
      isActive: true,
      startDate: '',
      endDate: '',
      conditionOperator: 'AND',
      conditions: [{ conditionType: 'TRANSACTION_AMOUNT_GTE', value: '1', secondaryValue: '' }],
      actionType: 'BLOCK_ACCRUAL',
      actionValue: '',
      mccCodes: '1111, 2222',
      selectedTierIds: [],
    },
  },
  {
    label: 'PRVS Tier, 50 Flat Points',
    description: 'Award 50 flat bonus points to PRVS tier customers on any transaction',
    category: 'Tier',
    selectedTierNames: ['PRVS'],
    formData: {
      name: PREDEFINED_RULE_DEFAULT_NAME,
      description: PREDEFINED_RULE_DEFAULT_DESCRIPTION,
      priority: '6',
      isActive: true,
      startDate: '',
      endDate: '',
      conditionOperator: 'AND',
      conditions: [{ conditionType: 'TRANSACTION_AMOUNT_GTE', value: '1', secondaryValue: '' }],
      actionType: 'ADD_FIXED_POINTS',
      actionValue: '50',
      mccCodes: '',
      selectedTierIds: [],
    },
  },
  {
    label: 'MCC Ratio Override',
    description: 'Override ratio for transactions',
    category: 'MCC',
    formData: {
      name: PREDEFINED_RULE_DEFAULT_NAME,
      description: PREDEFINED_RULE_DEFAULT_DESCRIPTION,
      priority: '7',
      isActive: true,
      startDate: '',
      endDate: '',
      conditionOperator: 'AND',
      conditions: [{ conditionType: 'TRANSACTION_AMOUNT_GTE', value: '1', secondaryValue: '' }],
      actionType: 'SET_RATIO',
      actionValue: '3',
      mccCodes: '1111, 2222',
      selectedTierIds: [],
    },
  },   
  {
    label: 'PRVS Retail 3x (Q1 2026)',
    description: '3x points for PRVS tier on retail > LKR 15,000 during Q1 2026',
    category: 'Combined',
    selectedTierNames: ['PRVS'],
    formData: {
      name: PREDEFINED_RULE_DEFAULT_NAME,
      description: PREDEFINED_RULE_DEFAULT_DESCRIPTION,
      priority: '8',
      isActive: true,
      startDate: '2026-01-01T00:00',
      endDate: '2026-03-31T23:59',
      conditionOperator: 'AND',
      conditions: [
        { conditionType: 'TRANSACTION_AMOUNT_GT', value: '15000', secondaryValue: '' },
        { conditionType: 'VOUCHER_BALANCE_LT', value: '5000', secondaryValue: '' },
      ],
      actionType: 'MULTIPLY_RATIO',
      actionValue: '3',
      mccCodes: '1111',
      selectedTierIds: [],
    },
  },
  {
    label: 'Loyal Big Spender +1.0 Ratio',
    description: '+1.0 ratio if transaction > LKR 20,000 OR voucher balance > LKR 2,000',
    category: 'Combined',
    formData: {
      name: PREDEFINED_RULE_DEFAULT_NAME,
      description: PREDEFINED_RULE_DEFAULT_DESCRIPTION,
      priority: '9',
      isActive: true,
      startDate: '',
      endDate: '',
      conditionOperator: 'OR',
      conditions: [
        { conditionType: 'TRANSACTION_AMOUNT_GT', value: '20000', secondaryValue: '' },
        { conditionType: 'VOUCHER_BALANCE_GT', value: '2000', secondaryValue: '' },
      ],
      actionType: 'ADD_RATIO',
      actionValue: '1',
      mccCodes: '',
      selectedTierIds: [],
    },
  },
  {
    label: '1.25x for Voucher LKR 200–800',
    description: '1.25x multiplier when voucher balance is between LKR 200 and LKR 800',
    category: 'Voucher',
    formData: {
      name: PREDEFINED_RULE_DEFAULT_NAME,
      description: PREDEFINED_RULE_DEFAULT_DESCRIPTION,
      priority: '10',
      isActive: true,
      startDate: '',
      endDate: '',
      conditionOperator: 'AND',
      conditions: [{ conditionType: 'VOUCHER_BALANCE_BETWEEN', value: '200', secondaryValue: '800' }],
      actionType: 'MULTIPLY_RATIO',
      actionValue: '1.25',
      mccCodes: '',
      selectedTierIds: [],
    },
  },
];

export const TOAST_MESSAGES = {
  success: 'Reward rule created successfully!',
  error: 'Failed to create reward rule. Please try again.',
};

export const VALIDATION_ERROR_MESSAGES = {
  name: 'Rule name is required.',
  priority: 'Priority is required and must be a positive integer.',
  conditionOperator: 'Condition operator is required.',
  actionType: 'Action type is required.',
  actionValue: 'Action value is required for this action type.',
  conditionType: 'Condition type is required.',
  conditionValue: 'Value is required.',
  dateRange: 'End date must be after start date.',
};
